import FooterWidget from './FooterWidget';

export default FooterWidget;
